export default __webpack_public_path__ + "static/media/chevron-right.inline.be9356c3.svg";